module.exports = __webpack_public_path__ + "img/icon-carousel-arrow-right.e86c1f9d.svg";